<template>
<!--  TODO STOP USING THIS FORM -->
  <v-dialog v-model="dialog" fullscreen>
    <template v-slot:activator="{ on }">
      <slot name="toggle" :on="on">
        <v-btn icon v-on="on">
          <v-icon v-if="!isEdit">
            add_box
          </v-icon>
          <v-icon v-else>
            edit
          </v-icon>
        </v-btn>
      </slot>
    </template>
    <v-card>
      <v-card-title class="headline grey lighten-2" primary-title>
        <slot name="title">New</slot>
      </v-card-title>
      <v-card-text>
        <slot name="content">Forms Go Here</slot>
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn color="error" dark @click="dialog = false">
          <v-icon left>fas fa-window-close</v-icon>
          Close
        </v-btn>
        <slot name="actions" :close="close" />
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "BaseForm",
  props: {
    isEdit: {
      type: Boolean,
      required: true,
      default: false
    }
  },
  data() {
    return {
      dialog: false
    };
  },
  methods: {
    close() {
      this.dialog = false;
    },
    open() {
      this.dialog = true;
    }
  }
};
</script>
